// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.copy-trading-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
}

.copy-trading-header__left {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.copy-trading-header__actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.75rem;
  margin-left: auto;
}

.copy-trading-header__hint {
  margin: 0.2rem 0 0;
  font-size: 0.8rem;
  color: var(--text-muted);
  font-weight: 500;
}

.copy-trading-stat {
  font-size: 0.85rem;
  color: var(--text-muted);
}

.copy-trading-stat strong {
  color: var(--text);
}

.copy-trading-table .badge {
  display: inline-block;
  padding: 0.25rem 0.6rem;
  font-size: 0.7rem;
  font-weight: 600;
  border-radius: 6px;
  text-transform: capitalize;
}

.copy-trading-table .badge--verified,
.copy-trading-table .badge--active {
  background: #dcfce7;
  color: #166534;
}

.copy-trading-table .badge--pending {
  background: #fef3c7;
  color: #92400e;
}

.copy-trading-table .badge--rejected,
.copy-trading-table .badge--inactive {
  background: #fee2e2;
  color: #b91c1c;
}

.copy-trading-filters {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 0.75rem 1rem;
  padding: 0 1.25rem 1rem;
}

.copy-trading-search {
  width: 100%;
  max-width: 420px;
  padding: 0.5rem 1rem;
  font-size: 0.9rem;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  background: #fff;
}

.copy-trading-search:focus {
  outline: none;
  border-color: #0f766e;
}

.copy-trading-page-limit {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--text-muted);
  flex: 0 1 120px;
}

.copy-trading-page-limit__select {
  padding: 0.5rem 1rem;
  font-size: 0.9rem;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  background: #fff;
  min-width: 100px;
}

.copy-trading-page-limit__select:focus {
  outline: none;
  border-color: #0f766e;
}

.copy-trading-refresh-btn {
  font-family: inherit;
  font-size: 0.85rem;
  font-weight: 600;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  border: 1px solid var(--border);
  background: #fff;
  color: var(--text);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  transition: background 0.2s, border-color 0.2s;
}

.copy-trading-refresh-btn:hover:not(:disabled) {
  background: #f8fafc;
  border-color: #0f766e;
  color: #0f766e;
}

.copy-trading-refresh-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.copy-trading-tabs {
  display: flex;
  gap: 0.25rem;
  padding: 0 1.25rem 0;
  border-bottom: 1px solid var(--border);
  background: #fff;
}

.copy-trading-tab {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.85rem 1.25rem;
  font-size: 0.875rem;
  font-weight: 500;
  font-family: inherit;
  color: var(--text-muted);
  background: none;
  border: none;
  border-bottom: 3px solid transparent;
  cursor: pointer;
  transition: color 0.2s, border-color 0.2s;
  margin-bottom: -1px;
}

.copy-trading-tab:hover {
  color: var(--text);
}

.copy-trading-tab--active {
  color: #0f766e;
  border-bottom-color: #0f766e;
}

.copy-trading-tab__count {
  min-width: 22px;
  padding: 0.15rem 0.5rem;
  font-size: 0.75rem;
  font-weight: 600;
  background: var(--main-bg);
  color: var(--text-muted);
  border-radius: 10px;
  text-align: center;
}

.copy-trading-tab--active .copy-trading-tab__count {
  background: #ccfbf1;
  color: #0f766e;
}

.copy-trading-error {
  margin: 0.75rem 1.25rem 0;
  padding: 0.75rem 1rem;
  background: #fee2e2;
  color: #b91c1c;
  border-radius: var(--radius);
  font-size: 0.9rem;
}

.copy-trading-note {
  margin: 0.75rem 1.25rem 0;
  padding: 0.7rem 1rem;
  background: #f0fdfa;
  color: #0f766e;
  border: 1px solid #99f6e4;
  border-radius: var(--radius);
  font-size: 0.85rem;
}

.copy-trading-content {
  padding: 1.25rem;
}

.copy-trading-table-wrap {
  width: 100%;
  overflow-x: auto;
}

.copy-trading-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.875rem;
}

.copy-trading-table thead {
  background: #f8fafc;
}

.copy-trading-table th {
  padding: 0.85rem 1rem;
  text-align: left;
  font-weight: 600;
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--text-muted);
  border-bottom: 2px solid var(--border);
  white-space: nowrap;
}

.copy-trading-table td {
  padding: 0.85rem 1rem;
  border-bottom: 1px solid var(--border);
  vertical-align: middle;
}

.copy-trading-table__empty {
  text-align: center;
  color: var(--text-muted);
  padding: 2.5rem 1rem !important;
}

.copy-trading-user {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  min-width: 140px;
}

.copy-trading-user strong {
  font-weight: 650;
  color: var(--text);
}

.copy-trading-user span {
  font-size: 0.8rem;
  color: var(--text-muted);
}

.copy-trading-uuid {
  font-size: 0.78rem;
  background: #f1f5f9;
  padding: 0.15rem 0.4rem;
  border-radius: 4px;
}

.copy-trading-role {
  display: inline-flex;
  align-items: center;
  padding: 0.2rem 0.55rem;
  border-radius: 999px;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.02em;
}

.copy-trading-role--master {
  background: #ecfdf5;
  color: #047857;
  border: 1px solid #a7f3d0;
}

.copy-trading-role--none {
  background: #f8fafc;
  color: #64748b;
  border: 1px solid #e2e8f0;
}

.copy-trading-config-flag {
  display: block;
  margin-top: 0.3rem;
  font-size: 0.7rem;
  font-weight: 650;
}

.copy-trading-config-flag--yes {
  color: #047857;
}

.copy-trading-config-flag--no {
  color: #b45309;
}

.copy-trading-config-flag--pending {
  color: var(--text-muted);
}

.copy-trading-table__actions {
  white-space: nowrap;
}

.copy-trading-view-btn,
.copy-trading-followers-btn,
.copy-trading-config-btn,
.copy-trading-promote-btn,
.copy-trading-demote-btn {
  font-family: inherit;
  font-size: 0.8rem;
  font-weight: 650;
  padding: 0.4rem 0.7rem;
  border-radius: 8px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  margin-right: 0.4rem;
  transition: background 0.2s, opacity 0.2s;
}

.copy-trading-view-btn {
  background: #fff;
  color: #0f766e;
  border: 1px solid rgba(15, 118, 110, 0.3);
}

.copy-trading-view-btn:hover {
  background: #f0fdfa;
}

.copy-trading-config-btn {
  background: #fff;
  color: #1d4ed8;
  border: 1px solid rgba(29, 78, 216, 0.28);
}

.copy-trading-config-btn:hover:not(:disabled) {
  background: #eff6ff;
}

.copy-trading-followers-btn {
  background: #fff;
  color: #6d28d9;
  border: 1px solid rgba(109, 40, 217, 0.28);
}

.copy-trading-followers-btn:hover:not(:disabled) {
  background: #f5f3ff;
}

.copy-trading-promote-btn {
  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);
  color: #fff;
  border: none;
}

.copy-trading-promote-btn:hover:not(:disabled) {
  opacity: 0.92;
}

.copy-trading-demote-btn {
  background: #fff;
  color: #b91c1c;
  border: 1px solid rgba(185, 28, 28, 0.3);
}

.copy-trading-demote-btn:hover:not(:disabled) {
  background: #fef2f2;
}

.copy-trading-promote-btn:disabled,
.copy-trading-demote-btn:disabled,
.copy-trading-config-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.copy-trading-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.75rem;
  padding-top: 1rem;
  font-size: 0.875rem;
}

.copy-trading-pagination__info {
  color: var(--text-muted);
}

.copy-trading-pagination__buttons {
  display: flex;
  gap: 0.5rem;
}

.copy-trading-pagination__btn {
  font-family: inherit;
  font-size: 0.85rem;
  font-weight: 600;
  padding: 0.45rem 0.85rem;
  border-radius: 8px;
  border: 1px solid var(--border);
  background: #fff;
  color: var(--text);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
}

.copy-trading-pagination__btn:hover:not(:disabled) {
  border-color: #0f766e;
  color: #0f766e;
}

.copy-trading-pagination__btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.copy-trading-modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

.copy-trading-modal {
  background: #fff;
  border-radius: 12px;
  padding: 1.5rem;
  max-width: 440px;
  width: 100%;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
}

.copy-trading-modal__title {
  margin: 0 0 0.75rem;
  font-size: 1.15rem;
  font-weight: 700;
  color: var(--text);
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.copy-trading-modal__title i {
  color: #0f766e;
}

.copy-trading-modal__text {
  margin: 0 0 1.25rem;
  font-size: 0.9rem;
  color: var(--text-muted);
  line-height: 1.5;
}

.copy-trading-modal__actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
}

.copy-trading-modal__cancel {
  font-family: inherit;
  font-size: 0.85rem;
  font-weight: 600;
  padding: 0.45rem 0.9rem;
  border-radius: 8px;
  border: 1px solid var(--border);
  background: #fff;
  color: var(--text);
  cursor: pointer;
}

.copy-trading-modal__cancel:hover:not(:disabled) {
  background: #f8fafc;
}

.copy-trading-modal__cancel:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

@media (max-width: 768px) {
  .copy-trading-tabs {
    overflow-x: auto;
  }

  .copy-trading-table__actions {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 0.35rem;
  }

  .copy-trading-view-btn,
  .copy-trading-followers-btn,
  .copy-trading-config-btn,
  .copy-trading-promote-btn,
  .copy-trading-demote-btn {
    margin-right: 0;
    justify-content: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/CopyTrading/CopyTradingManagementPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,oBAAoB;EACpB,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,wBAAwB;EACxB,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,eAAe;EACf,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;EACxB,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;;EAKE,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,YAAY;EACd;;EAEA;;;;;IAKE,eAAe;IACf,uBAAuB;EACzB;AACF","sourcesContent":[".copy-trading-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n.copy-trading-header__left {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.copy-trading-header__actions {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.75rem;\n  margin-left: auto;\n}\n\n.copy-trading-header__hint {\n  margin: 0.2rem 0 0;\n  font-size: 0.8rem;\n  color: var(--text-muted);\n  font-weight: 500;\n}\n\n.copy-trading-stat {\n  font-size: 0.85rem;\n  color: var(--text-muted);\n}\n\n.copy-trading-stat strong {\n  color: var(--text);\n}\n\n.copy-trading-table .badge {\n  display: inline-block;\n  padding: 0.25rem 0.6rem;\n  font-size: 0.7rem;\n  font-weight: 600;\n  border-radius: 6px;\n  text-transform: capitalize;\n}\n\n.copy-trading-table .badge--verified,\n.copy-trading-table .badge--active {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.copy-trading-table .badge--pending {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n.copy-trading-table .badge--rejected,\n.copy-trading-table .badge--inactive {\n  background: #fee2e2;\n  color: #b91c1c;\n}\n\n.copy-trading-filters {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  gap: 0.75rem 1rem;\n  padding: 0 1.25rem 1rem;\n}\n\n.copy-trading-search {\n  width: 100%;\n  max-width: 420px;\n  padding: 0.5rem 1rem;\n  font-size: 0.9rem;\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  background: #fff;\n}\n\n.copy-trading-search:focus {\n  outline: none;\n  border-color: #0f766e;\n}\n\n.copy-trading-page-limit {\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: var(--text-muted);\n  flex: 0 1 120px;\n}\n\n.copy-trading-page-limit__select {\n  padding: 0.5rem 1rem;\n  font-size: 0.9rem;\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  background: #fff;\n  min-width: 100px;\n}\n\n.copy-trading-page-limit__select:focus {\n  outline: none;\n  border-color: #0f766e;\n}\n\n.copy-trading-refresh-btn {\n  font-family: inherit;\n  font-size: 0.85rem;\n  font-weight: 600;\n  padding: 0.5rem 1rem;\n  border-radius: 8px;\n  border: 1px solid var(--border);\n  background: #fff;\n  color: var(--text);\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.45rem;\n  transition: background 0.2s, border-color 0.2s;\n}\n\n.copy-trading-refresh-btn:hover:not(:disabled) {\n  background: #f8fafc;\n  border-color: #0f766e;\n  color: #0f766e;\n}\n\n.copy-trading-refresh-btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.copy-trading-tabs {\n  display: flex;\n  gap: 0.25rem;\n  padding: 0 1.25rem 0;\n  border-bottom: 1px solid var(--border);\n  background: #fff;\n}\n\n.copy-trading-tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.85rem 1.25rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  font-family: inherit;\n  color: var(--text-muted);\n  background: none;\n  border: none;\n  border-bottom: 3px solid transparent;\n  cursor: pointer;\n  transition: color 0.2s, border-color 0.2s;\n  margin-bottom: -1px;\n}\n\n.copy-trading-tab:hover {\n  color: var(--text);\n}\n\n.copy-trading-tab--active {\n  color: #0f766e;\n  border-bottom-color: #0f766e;\n}\n\n.copy-trading-tab__count {\n  min-width: 22px;\n  padding: 0.15rem 0.5rem;\n  font-size: 0.75rem;\n  font-weight: 600;\n  background: var(--main-bg);\n  color: var(--text-muted);\n  border-radius: 10px;\n  text-align: center;\n}\n\n.copy-trading-tab--active .copy-trading-tab__count {\n  background: #ccfbf1;\n  color: #0f766e;\n}\n\n.copy-trading-error {\n  margin: 0.75rem 1.25rem 0;\n  padding: 0.75rem 1rem;\n  background: #fee2e2;\n  color: #b91c1c;\n  border-radius: var(--radius);\n  font-size: 0.9rem;\n}\n\n.copy-trading-note {\n  margin: 0.75rem 1.25rem 0;\n  padding: 0.7rem 1rem;\n  background: #f0fdfa;\n  color: #0f766e;\n  border: 1px solid #99f6e4;\n  border-radius: var(--radius);\n  font-size: 0.85rem;\n}\n\n.copy-trading-content {\n  padding: 1.25rem;\n}\n\n.copy-trading-table-wrap {\n  width: 100%;\n  overflow-x: auto;\n}\n\n.copy-trading-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.875rem;\n}\n\n.copy-trading-table thead {\n  background: #f8fafc;\n}\n\n.copy-trading-table th {\n  padding: 0.85rem 1rem;\n  text-align: left;\n  font-weight: 600;\n  font-size: 0.72rem;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: var(--text-muted);\n  border-bottom: 2px solid var(--border);\n  white-space: nowrap;\n}\n\n.copy-trading-table td {\n  padding: 0.85rem 1rem;\n  border-bottom: 1px solid var(--border);\n  vertical-align: middle;\n}\n\n.copy-trading-table__empty {\n  text-align: center;\n  color: var(--text-muted);\n  padding: 2.5rem 1rem !important;\n}\n\n.copy-trading-user {\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n  min-width: 140px;\n}\n\n.copy-trading-user strong {\n  font-weight: 650;\n  color: var(--text);\n}\n\n.copy-trading-user span {\n  font-size: 0.8rem;\n  color: var(--text-muted);\n}\n\n.copy-trading-uuid {\n  font-size: 0.78rem;\n  background: #f1f5f9;\n  padding: 0.15rem 0.4rem;\n  border-radius: 4px;\n}\n\n.copy-trading-role {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.2rem 0.55rem;\n  border-radius: 999px;\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n}\n\n.copy-trading-role--master {\n  background: #ecfdf5;\n  color: #047857;\n  border: 1px solid #a7f3d0;\n}\n\n.copy-trading-role--none {\n  background: #f8fafc;\n  color: #64748b;\n  border: 1px solid #e2e8f0;\n}\n\n.copy-trading-config-flag {\n  display: block;\n  margin-top: 0.3rem;\n  font-size: 0.7rem;\n  font-weight: 650;\n}\n\n.copy-trading-config-flag--yes {\n  color: #047857;\n}\n\n.copy-trading-config-flag--no {\n  color: #b45309;\n}\n\n.copy-trading-config-flag--pending {\n  color: var(--text-muted);\n}\n\n.copy-trading-table__actions {\n  white-space: nowrap;\n}\n\n.copy-trading-view-btn,\n.copy-trading-followers-btn,\n.copy-trading-config-btn,\n.copy-trading-promote-btn,\n.copy-trading-demote-btn {\n  font-family: inherit;\n  font-size: 0.8rem;\n  font-weight: 650;\n  padding: 0.4rem 0.7rem;\n  border-radius: 8px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  margin-right: 0.4rem;\n  transition: background 0.2s, opacity 0.2s;\n}\n\n.copy-trading-view-btn {\n  background: #fff;\n  color: #0f766e;\n  border: 1px solid rgba(15, 118, 110, 0.3);\n}\n\n.copy-trading-view-btn:hover {\n  background: #f0fdfa;\n}\n\n.copy-trading-config-btn {\n  background: #fff;\n  color: #1d4ed8;\n  border: 1px solid rgba(29, 78, 216, 0.28);\n}\n\n.copy-trading-config-btn:hover:not(:disabled) {\n  background: #eff6ff;\n}\n\n.copy-trading-followers-btn {\n  background: #fff;\n  color: #6d28d9;\n  border: 1px solid rgba(109, 40, 217, 0.28);\n}\n\n.copy-trading-followers-btn:hover:not(:disabled) {\n  background: #f5f3ff;\n}\n\n.copy-trading-promote-btn {\n  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);\n  color: #fff;\n  border: none;\n}\n\n.copy-trading-promote-btn:hover:not(:disabled) {\n  opacity: 0.92;\n}\n\n.copy-trading-demote-btn {\n  background: #fff;\n  color: #b91c1c;\n  border: 1px solid rgba(185, 28, 28, 0.3);\n}\n\n.copy-trading-demote-btn:hover:not(:disabled) {\n  background: #fef2f2;\n}\n\n.copy-trading-promote-btn:disabled,\n.copy-trading-demote-btn:disabled,\n.copy-trading-config-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.copy-trading-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  padding-top: 1rem;\n  font-size: 0.875rem;\n}\n\n.copy-trading-pagination__info {\n  color: var(--text-muted);\n}\n\n.copy-trading-pagination__buttons {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.copy-trading-pagination__btn {\n  font-family: inherit;\n  font-size: 0.85rem;\n  font-weight: 600;\n  padding: 0.45rem 0.85rem;\n  border-radius: 8px;\n  border: 1px solid var(--border);\n  background: #fff;\n  color: var(--text);\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n}\n\n.copy-trading-pagination__btn:hover:not(:disabled) {\n  border-color: #0f766e;\n  color: #0f766e;\n}\n\n.copy-trading-pagination__btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.copy-trading-modal-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1000;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n}\n\n.copy-trading-modal {\n  background: #fff;\n  border-radius: 12px;\n  padding: 1.5rem;\n  max-width: 440px;\n  width: 100%;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);\n}\n\n.copy-trading-modal__title {\n  margin: 0 0 0.75rem;\n  font-size: 1.15rem;\n  font-weight: 700;\n  color: var(--text);\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.copy-trading-modal__title i {\n  color: #0f766e;\n}\n\n.copy-trading-modal__text {\n  margin: 0 0 1.25rem;\n  font-size: 0.9rem;\n  color: var(--text-muted);\n  line-height: 1.5;\n}\n\n.copy-trading-modal__actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.75rem;\n}\n\n.copy-trading-modal__cancel {\n  font-family: inherit;\n  font-size: 0.85rem;\n  font-weight: 600;\n  padding: 0.45rem 0.9rem;\n  border-radius: 8px;\n  border: 1px solid var(--border);\n  background: #fff;\n  color: var(--text);\n  cursor: pointer;\n}\n\n.copy-trading-modal__cancel:hover:not(:disabled) {\n  background: #f8fafc;\n}\n\n.copy-trading-modal__cancel:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n@media (max-width: 768px) {\n  .copy-trading-tabs {\n    overflow-x: auto;\n  }\n\n  .copy-trading-table__actions {\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    gap: 0.35rem;\n  }\n\n  .copy-trading-view-btn,\n  .copy-trading-followers-btn,\n  .copy-trading-config-btn,\n  .copy-trading-promote-btn,\n  .copy-trading-demote-btn {\n    margin-right: 0;\n    justify-content: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
